import { status } from '../../helpers'

const getRecipientStoreDefaultState = () => {
  return {
    loadBarChart: status.INITIALIZED,
    countGiftsSent: 0,
    historicalOrdersSent: {
      labels: [],
      datasets: [
        {
          label: 'Gifts sent last 30 days',
          backgroundColor: '#FEF3EF',
          data: [],
          fill: false
        }
      ]
    },
    loadingTrendingGifts: status.INITIALIZED,
    trendingGiftsList: [],
    loadAvergaShipments: status.INITIALIZED,
    averageShipments: 0,
    remainingShipments: 0,
    shipmentsChartData: {
      labels: ['Shipped', 'Remaining'],
      datasets: [
        {
          data: [0, 0],
          backgroundColor: ['#25282a', '#cfcfcf'],
          hoverBorderWidth: 0
        }
      ]
    },
    averageShipment: 0
  }
}

export default getRecipientStoreDefaultState
